import { AddIcon } from "@sw-sw/lib-ui";

export default AddIcon;
